import { render, staticRenderFns } from "./rule-config-task.vue?vue&type=template&id=558588cb"
import script from "./rule-config-task.vue?vue&type=script&lang=js"
export * from "./rule-config-task.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports